// src/queries/useOnboarding.ts
import { OnboardingStatus } from "@/types/onboarding";
import { useQuery } from "@tanstack/react-query";
import { onboardingService } from "../services/onboardingServices";

export const useOnboardingStatus = (userId: number) => {
  return useQuery<OnboardingStatus>({
    queryKey: ["onboardingStatus", userId],
    queryFn: () => onboardingService.checkStatus(userId),
    enabled: Boolean(userId),
  });
};

export const useAmazonProfileStatus = (userId: number) => {
  return useQuery<OnboardingStatus>({
    queryKey: ["amazonProfileStatus", userId],
    queryFn: () => onboardingService.checkAmazonProfile(userId),
  });
};
